import React from "react";

export const ScatteredThunderStormsDayIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="38" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M52.587 23.407c-2.215-7.601-9.312-12.992-17.521-12.992-8.92 0-16.442 6.346-17.954 14.837-7.62 1.035-13.445 7.483-13.445 15.232 0 6.01 3.528 11.388 8.938 13.909a1.55 1.55 0 001.309-2.809c-4.332-2.019-7.149-6.311-7.149-11.1 0-6.519 5.189-11.9 11.793-12.26l1.319-.071.138-1.314c.79-7.534 7.274-13.326 15.05-13.326 7.178 0 13.32 4.948 14.798 11.75l.275 1.263 1.292-.044c.105-.003.21-.005.316-.005 4.524 0 8.321 3.3 8.908 7.65l.234 1.737 1.695-.445a9.16 9.16 0 012.332-.3c4.968 0 8.986 3.955 8.986 8.822 0 4.866-4.017 8.821-8.986 8.821H35.861a1.55 1.55 0 000 3.099h29.054C71.584 55.86 77 50.53 77 43.94c0-6.59-5.416-11.92-12.085-11.92-.511 0-1.019.031-1.52.093-1.348-4.818-5.665-8.357-10.808-8.707z"
                        fill="#717277"
                    />
                    <path
                        d="M43.982 64.212a1.55 1.55 0 10-2.191-2.19l-5.113 5.112a1.55 1.55 0 002.191 2.19l5.113-5.112zM64.639 64.212a1.55 1.55 0 00-2.191-2.19l-5.112 5.112a1.55 1.55 0 002.19 2.19l5.113-5.112z"
                        fill="#9ADAFF"
                    />
                    <path
                        d="M35.168 46.876c1.352-.004 2.06 1.604 1.145 2.599L18.895 68.387c-1.217 1.32-3.33-.14-2.525-1.744l5.964-11.896h-7.818c-1.354 0-2.056-1.614-1.134-2.605L30.977 33.23c1.213-1.303 3.306.132 2.528 1.733l-5.8 11.936 7.462-.023zm-3.538 3.11l-6.398.02a1.55 1.55 0 01-1.399-2.227l2.361-4.858-8.12 8.727h6.77a1.55 1.55 0 011.385 2.244l-2.153 4.296 7.554-8.202zM55.87 11.872l.584 2.75a1.55 1.55 0 003.031-.644l-.584-2.75a1.55 1.55 0 00-3.031.644zM66.971 12.722l-1.53 2.359a1.55 1.55 0 102.598 1.687l1.531-2.358a1.55 1.55 0 10-2.599-1.688zM74.214 21.172l-2.75.584a1.55 1.55 0 10.644 3.031l2.75-.584a1.55 1.55 0 00-.644-3.031zM55.83 22.582a5.164 5.164 0 117.809 6.538 1.55 1.55 0 102.011 2.357 8.263 8.263 0 10-12.495-10.46 1.55 1.55 0 002.675 1.565z"
                        fill="#FCBA38"
                    />
                </g>
            </g>
        </g>
    </svg>
);
